import React from 'react';

import Icon from 'common/components/Icon';

import styles from './index.module.css';

const IconMap = {
  USDC: <Icon.Usdc />,
  BTC: <Icon.Btc />,
  SUI: <Icon.Sui />,
  ETH: <Icon.Eth />,
  EGLD: <Icon.Egld />,
  POL: <Icon.Pol />,
  USDT: <Icon.Usdt />,
  UTK: <Icon.UtK />,
  DASH: <Icon.Dash />,
};

export const TradedAmountUI = ({ currency, value }) => (
  <div className={styles.root}>
    <div className={styles.icon}>{IconMap[currency]}</div>
    <div>
      <span>{value}</span> <span>{currency}</span>
    </div>
  </div>
);

const TradedAmount = ({ value }) => {
  if (!value || (!value.get('currency') && !value.get('value'))) {
    return (
      <div className={styles.root}>
        <div>-</div>
      </div>
    );
  }

  return (
    <TradedAmountUI
      currency={value.get('currency')}
      value={value.get('value')}
    />
  );
};

export default TradedAmount;
